import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";

import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";

import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import {
	getKYCAccountTypeList,
	resetGetKYCAccountTypeList
} from "../../redux/actions/getKYCAccountTypeListAction";

import {
	resetapproveOrRejectManualUpgradeKYCList,
	approveOrRejectManualUpgradeKYC
} from "../../redux/actions/approveOrRejectManualUpgradeKYCAction";

import {
	getManualUpgradeKycList,
	resetGetManualUpgradeKycList
} from "../../redux/actions/getManualUpgradeKycListAction";
import { useSelector, useDispatch } from "react-redux";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const ManualUpgrade = () => {
	const classes = useStyles();
	const [accountType, setAccountType] = useState("");
	const [statusType, setStatusType] = useState("All");
	const [mobileNumber, setMobileNumber] = useState("");
	const [emailId, setEmailId] = useState("");
	const [getKYCAccountType, setGetKYCAccountType] = useState([]);
	const [getKycAccountTypeStatus, setgetKycAccountTypeStatus] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [
		approveOrRejectManualUpgradeKYCResStatus,
		setapproveOrRejectManualUpgradeKYCResStatus
	] = useState(false);

	const [getKYCAccountTypeArray, setGetKYCAccountTypeArray] = useState([]);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [getManualUpgradeKycListStatus, setGetManualUpgradeKycListStatus] =
		useState(false);
	const [getManualUpgradeKycListArray, setGetManualUpgradeKycListArray] =
		useState([]);
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const dispatch = useDispatch();
	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const getKYCAccountTypeListRes = useSelector(
		({ getKYCAccountTypeList }) => getKYCAccountTypeList
	);

	const getManualUpgradeKycRes = useSelector(
		({ getManualUpgradeKyc }) => getManualUpgradeKyc
	);

	const approveOrRejectManualUpgradeKYCRes = useSelector(
		({ approveOrRejectManualUpgradeKYC }) => approveOrRejectManualUpgradeKYC
	);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "statusType") {
			setStatusType(value);
		}

		if (name === "accountType") {
			setAccountType(value);
		}

		if (name === "emailId") {
			setEmailId(value);
		}

		if (name === "mobileNumber") {
			setMobileNumber(value);
		}
	};

	const setgetKycAccountTypeStatusFunc = () => {
		setgetKycAccountTypeStatus(true);
		const getKYCAccountTypeListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(getKYCAccountTypeList(getKYCAccountTypeListReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setgetKycAccountTypeStatusFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const getKycAccountTypeStatusFunc = () => {
		if (getKycAccountTypeStatus) {
			if (getKYCAccountTypeListRes.data.status == "success") {
				setGetKYCAccountTypeArray(
					[].concat(getKYCAccountTypeListRes.data.accountTypeList)
				);
			}
			if (getKYCAccountTypeListRes.data.status == "Failed") {
				setGetKYCAccountTypeArray(getKYCAccountTypeListRes.data);
				if (
					getKYCAccountTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKYCAccountTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKYCAccountTypeListRes.data.status == "failed") {
				setGetKYCAccountTypeArray(getKYCAccountTypeListRes.data);
				if (
					getKYCAccountTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKYCAccountTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getKycAccountTypeStatusFunc();
	}, [getKYCAccountTypeListRes.data.status]);

	const getManualUpgradeKycListReq = () => {
		setGetManualUpgradeKycListStatus(true);
		setIsLoading(true);
		const getManualUpgradeKyc = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				// accountType: accountType == "PREMIUM" ? "" : "",
				accountType: accountType,
				kycStatus: statusType == "All" ? "1" : statusType,
				email: emailId,
				phoneNo: mobileNumber
			}
		};

		return dispatch(getManualUpgradeKycList(getManualUpgradeKyc, authToken));
	};

	const getManualUpgradeKycListStatusFunc = () => {
		if (getManualUpgradeKycListStatus) {
			if (getManualUpgradeKycRes.data.status == "Success") {
				setIsLoading(false);
				setGetManualUpgradeKycListArray(
					[].concat(
						getManualUpgradeKycRes.data.customerMasterDetailsResponseVOList
					)
				);
			}
			if (getManualUpgradeKycRes.data.status == "Failed") {
				setIsLoading(false);
				setGetManualUpgradeKycListArray(getManualUpgradeKycRes.data);
				if (
					getManualUpgradeKycRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getManualUpgradeKycRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getManualUpgradeKycRes.data.status == "failed") {
				setIsLoading(false);
				setGetManualUpgradeKycListArray(getManualUpgradeKycRes.data);
				if (
					getManualUpgradeKycRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getManualUpgradeKycRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getManualUpgradeKycListStatusFunc();
	}, [getManualUpgradeKycRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const closedManualOtpRequest = (customerId, kycAccount, requestStatus) => {
		setapproveOrRejectManualUpgradeKYCResStatus(true);
		const closedManualOtpRequestReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				kycUpgradeId: "1",
				kycAccount: kycAccount,
				action: "APPROVE"
				// action: "APPROVE",
			}
		};

		return dispatch(
			approveOrRejectManualUpgradeKYC(closedManualOtpRequestReq, authToken)
		);
	};

	//approveOrRejectManualUpgradeKYCRes

	const approveOrRejectManualUpgradeKYCResStatusFunc = () => {
		if (approveOrRejectManualUpgradeKYCResStatus) {
			if (approveOrRejectManualUpgradeKYCRes.data.status == "success") {
				setNotificationOpen(true);
			}
			if (approveOrRejectManualUpgradeKYCRes.data.status == "Failed") {
				setNotificationOpen(true);
				if (
					approveOrRejectManualUpgradeKYCRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					approveOrRejectManualUpgradeKYCRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (approveOrRejectManualUpgradeKYCRes.data.status == "failed") {
				setNotificationOpen(true);
				if (
					approveOrRejectManualUpgradeKYCRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					approveOrRejectManualUpgradeKYCRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		approveOrRejectManualUpgradeKYCResStatusFunc();
	}, [approveOrRejectManualUpgradeKYCRes.data.status]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Account Type"
								type="name"
								fullWidth
								variant="standard"
								name="accountType"
								value={accountType || ""}
								onChange={handleChange}
							>
								{(() => {
									if (getKycAccountTypeStatus) {
										if (!getKycAccountTypeStatus) {
											return <MenuItem>No Data</MenuItem>;
										}
										return getKYCAccountTypeArray.map((c) => (
											<MenuItem value={c} key={c}>
												{c}
											</MenuItem>
										));
									}
								})()}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Email"
								type="text"
								fullWidth
								value={emailId || ""}
								name="emailId"
								onChange={handleChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Mobile No"
								type="tel"
								fullWidth
								value={mobileNumber}
								name="mobileNumber"
								onChange={handleChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Status"
								type="name"
								fullWidth
								variant="standard"
								name="statusType"
								value={statusType || ""}
								onChange={handleChange}
							>
								<MenuItem value="All">All</MenuItem>
								<MenuItem value="Pending">Pending</MenuItem>
								<MenuItem value="APPROVE">Approved</MenuItem>
								<MenuItem value="REJECT">Rejected</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getManualUpgradeKycListReq}
							>
								Search
							</Button>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getManualUpgradeKycListArray.length == undefined ||
					!getManualUpgradeKycListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3"
									variant="secondary"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow style={{ background: "#00b9f5" }}>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Sr. No{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												customerEmail
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												kycAccount
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												mobNumber
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Actions
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getManualUpgradeKycListArray &&
											[]
												.concat(getManualUpgradeKycListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.customerId}>
														<TableCell align="center">
															{row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.customerEmail}
														</TableCell>
														<TableCell align="center">
															{row.kycAccount}
														</TableCell>
														<TableCell align="center">
															{row.mobNumber}
														</TableCell>
														<TableCell align="center">
															{row.requestStatus}
														</TableCell>

														<TableCell align="center">
															{row.requestStatus == "Approved" ? (
																"-"
															) : (
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		closedManualOtpRequest(
																			row.customerId,
																			row.kycAccount,
																			row.requestStatus
																		)
																	}
																>
																	APPROVE
																</CustomButton>
															)}

															{/* <CustomButton
                            style={{
                              padding: "8px",
                            }}
                            onClick={() =>
                              closedManualOtpRequest(
                                row.customerId,
                                row.kycAccount,
                                row.requestStatus
                              )
                            }
                          >
                           
                          </CustomButton> */}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getManualUpgradeKycListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{approveOrRejectManualUpgradeKYCRes.data && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent>
							<h3>{approveOrRejectManualUpgradeKYCRes.data.description}</h3>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleNoticationClose}>Ok</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default ManualUpgrade;
